var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20.958 11.8125L0 23.625V0Z",
    fill: "url(#paint0_linear_164_14561)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6299 0L47.5879 11.8125L26.6299 23.625V0Z",
    fill: "url(#paint1_linear_164_14561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14561",
    x1: 3217.9,
    y1: 348.231,
    x2: -34513.3,
    y2: 348.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14561",
    x1: 3244.53,
    y1: 348.231,
    x2: -34486.7,
    y2: 348.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL3);
export default __webpack_public_path__ + "static/media/l3.c5d73672a3c8d4a6f78824c6a98971e0.svg";
export { ForwardRef as ReactComponent };